module.exports = __webpack_public_path__ + "img/save-02.17b9b76c.svg";